import React from "react";
import { Link } from "react-router-dom"; 
import "./EventsSection.css";

const EventsSection = ({ events = [] }) => {
  return (
    <section className="events-section">
      <h2 className="events-title">Upcoming Events</h2>

      <div className="events-grid">
        {events.map((ev, index) => (
          <div key={index} className="event-card">
            <div
              className="event-image"
            >
              <img
                src={ev.image}
                alt={`${ev.title} at NIECCE`}
                title={`${ev.title} at NIECCE`}
                className="event-bg-image"
              />
              <div className="event-overlay"></div>
            </div>

            <div className="event-content">
              <h3 className="event-name">{ev.title}</h3>

              <div className="event-meta">
                <span>{ev.date}</span>
                <span className="dot">•</span>
                <span>{ev.location}</span>
              </div>

              <p className="event-desc">{ev.description}</p>

              {/* Use Link instead of <a> for React Router */}
              <Link to={`/events/${ev.slug}`} className="event-btn">
                Details →
              </Link>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default EventsSection;
